<style scoped>
.upload-file-input {
  display: none;
}

.dashed-border {
  border-style: dashed !important;
}

.upload-container {
  background-color: #f5f5f5 !important;
}

.upload-container-icon {
  padding-top: 80px;
}

.small-font {
  font-size: 90%;
}
</style>

<template>
  <div style="position: relative;">
    <v-overlay
      absolute
      class="blocked-cursor"
      :opacity="0.05"
      :value="disabled"
    />
    <v-card
      flat
      outlined
      class="upload-container py-0 dashed-border pointer-cursor"
      :style="{ 'height': height }"
      @dragover.prevent
      @drop.prevent
      @click="browseFiles"
    >
      <v-card-text
        class="pa-0"
        @drop="handleFileDrop"
      >
        <v-file-input
          class="upload-file-input"
          ref="uploadFileInput"
          id="uploader-file-input"
          :multiple="multiple"
          :accept="accept ? accept.join(',') : null"
          :rules="rules"
          :value="value"
          @change="handleFileInput"
        />
        <div
          class="d-flex justify-center align-content-center flex-wrap"
          :style="{ 'height': height }"
        >
          <div class="text-center">
            <div>
              <v-icon x-large>mdi-upload</v-icon>
            </div>
            <div>{{ text }}</div>
            <div v-if="tip" class="small-font">{{ tip }}</div>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card flat class="py-0" v-if="value && value.length">
      <v-card-text class="pa-0">
        <v-list subheader dense>
          <v-subheader class="pl-3 mb-n1">
            Selected Files ({{ value.length }})
          </v-subheader>

          <v-chip
            v-for="(file, idx) in value" :key="idx"
            class="ma-2"
            close
            close-icon="mdi-close"
            :id="`file-upload-remove-${idx}-btn`"
            @click:close="removeFile(idx)"
          >
            {{ file.name }}
          </v-chip>

        </v-list>
        <anchor-right-content v-if="showUploadButton" container-classes="mx-0 pr-3 pb-3">
          <v-btn
            id="uploader-upload-btn"
            :loading="loading"
            color="primary"
            @click="$emit('upload', value)"
          >
            Upload
          </v-btn>
        </anchor-right-content>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import AnchorRightContent from '../RightContent';

export default {
  name: 'AnchorFileUploader',
  components: {
    AnchorRightContent,
  },
  props: {
    value: { Array },
    showUploadButton: {
      type: Boolean,
      default: false,
    },
    rules: Array,
    height: {
      type: [String, Number],
      default: '260px',
    },
    disabled: Boolean,
    multiple: Boolean,
    accept: Array,
    text: {
      type: String,
      default: 'Choose files or drag and drop here',
    },
    tip: String,
    loading: Boolean,
  },
  methods: {
    browseFiles() {
      this.$refs.uploadFileInput.$refs.input.click();
    },
    handleFileDrop(event) {
      this.handleValidFiles([...event.dataTransfer.files]);
    },
    handleFileInput(event) {
      this.handleValidFiles([...event]);
    },
    handleValidFiles(files) {
      let validFiles = this.accept ? files.filter(file => this.accept.includes(file.type)) : files;
      if (this.multiple === false) {
        validFiles = validFiles.length ? [validFiles[0]] : [];
      }
      this.$emit('input', validFiles);
    },
    removeFile(idx) {
      const files = this.value;
      files.splice(idx, 1);
      this.$emit('input', files);
    },
  },
};
</script>
